import { warningYellowIcon } from '#/assets';

interface WarningProps {
  children?: React.ReactNode;
}

const Warning = (props: WarningProps) => {
  const { children = 'Warning' } = props;

  return (
    <div className="d-flex mt-1">
      <div
        className="d-flex align-items-baseline"
        style={{ position: 'relative', top: 2 }}
      >
        <img
          className="mr-1"
          style={{ width: 14 }}
          src={warningYellowIcon}
          alt="warning"
        />
      </div>
      <span style={{ fontSize: 12, opacity: 0.7 }}>{children}</span>
    </div>
  );
};

export default Warning;
